// Module
var code = "<div class=bible> <div class=bibletext> <p> </p><h2 class=pn>Psalm&nbsp;7</h2><p><span class=cwvnum>1</span>&nbsp;&nbsp;O Lord my God, in you I take refuge;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;save me from all who pursue me, and deliver me,<br> </p> </div></div>";
// Exports
module.exports = code;